export default function formatMeasurement(measurement) {
  return (measurement / 10).toFixed(1);
}
